<template>
  <div class="order_home">
    <div class="top_content">
      <div class="white_box">
        <div class="big_title">
          <div>你好！</div>
          <div> 欢迎登录亚丁</div>
        </div>
        <div class="phone_imei">手机号/IMEI</div>
        <div class="input_btn ">

          <div class="search">
            <img class="icon" src="../../assets/images/icon_ss.png" alt="">
            <input type="text" placeholder="请输入手机号或IMEI" v-model="keywords">
          </div>
        </div>

        <div class="btn btn-top">
          <van-button color="#577BB5" size="large" @click='logon()'>登录</van-button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {
  logonUnicom
} from "@/api/unicom";

export default {
  name: "orderhome",
  data() {
    return {
      keywords: '',
    }
  },
  mounted() {

  },
  methods: {
    logon() {
      logonUnicom(
        {
          keywords: this.keywords
        }
      )
        .then((res) => {
          if (res && res.code) {
            const { data } = res
            this.$router.push({ path: "/Unicom/index", query: { data: JSON.stringify(data) } });
          } else {
            this.$toast(res.msg || "登录失败！");
          }
        })
        .catch((err) => {
          this.$toast((err && err.msg) || "登录失败！");
        });
    }
  },
}
</script>

<style lang="less" scoped>
.order_home {
  position: relative;
  width: 100vw;
  height: 100vh;

  .top_content {
    padding: 1px 0;
    background-image: url(../../assets/images/unicom/img_back.png);
    width: 100%;
    height: 896px;
    background-size: 100% 100%;

    .white_box {
      position: absolute;
      left: 30px;
      right: 30px;

      .big_title {
        margin: 120px 0 100px 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 40px;
        color: #1D1E20;
        line-height: 68px;
        letter-spacing: 1px;
        text-align: left;
        font-style: normal;
      }

      .phone_imei {
        margin: 0 0 20px 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
        text-align: left;
        font-style: normal;
      }

      .mt_a_60 {
        margin: 60px auto;
      }

      .input_btn {
        width: calc(100vw - 120px);
        height: 80px;
        border-radius: 40px;
        margin: 0 60px 60px 30px;

        .img_seach {
          .img_w_H {
            img {
              width: 24px;
            }
          }

          img {
            width: 40px;
          }
        }
      }
    }
  }





  .btn {
    width: calc(100vw - 120px);
    margin: auto;
    margin-bottom: 35px;

    button {
      height: 88px;
    }
  }

  .btn-top {
    button {
      box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.4);
    }
  }

  .btn-bottom {
    button {
      box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.1);
      color: #577BB5 !important;
    }
  }
}

.search {
  width: calc(100vw - 120px);
  height: 88px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 34px;

  input {
    background: transparent;
    width: 500px;
    padding-left: 28px;

    &::-webkit-input-placeholder {
      font-size: 30px !important;
    }

    &::placeholder {
      font-size: 30px !important;
    }
  }

  .icon {
    width: 42px;
    height: 42px;

    &.arrow {
      width: 30px;
      height: 30px;
    }
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 18px;
  }
}
</style>
